import styled from "styled-components";

export default styled.article`
  box-sizing: border-box;
  max-width: ${({ theme }) => theme.mainMaxWidth};
  min-height: 1rem;
  width: 100%;
`;
